import { render, staticRenderFns } from "./EditHeadManage.vue?vue&type=template&id=3e421d44&"
import script from "./EditHeadManage.vue?vue&type=script&lang=js&"
export * from "./EditHeadManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports